import {
	HomeOutlined,
	LoginOutlined,
	LogoutOutlined,
	UserOutlined,
} from "@ant-design/icons";
import React from "react";
import { ROLES } from "./permissions";

export const routes = {
	home: {
		key: "home",
		slug: "home",
		to: "/home",
		title: "Inicio",
		icon: <HomeOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	profile: {
		key: "profile",
		slug: "profile",
		to: "/profile",
		title: "Perfil",
		icon: <UserOutlined />,
		showInMenu: false,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	users: {
		key: "users",
		slug: "users",
		to: "/users",
		title: "Usuarios",
		icon: <UserOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},

	login: {
		key: "login",
		slug: "login",
		to: "/login",
		title: "LOGIN",
		icon: <LoginOutlined />,
		showInMenu: false,
		showHeader: false,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

tasks: {
    key: "tasks",
    slug: "tasks",
    to: "/tasks",
    title: "Tareas",
    icon: <HomeOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
},

	projects: {
		key: "projects",
		slug: "projects",
		to: "/projects",
		title: "ProjectTool",
		icon: <HomeOutlined />,
		showInMenu: true,
		showHeader: false,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	"projects/admin": {
		key: "projectsAdmin",
		slug: "projects/admin",
		to: "/projects/admin",
		title: "Proyectos (admin)",
		icon: <HomeOutlined />,
		showInMenu: false,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},
workers: {
    key: "workers",
    slug: "workers",
    to: "/workers",
    title: "Trabajadores",
    icon: <HomeOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
},
	logout: {
		key: "logout",
		slug: "logout",
		to: "/logout",
		title: "Log out",
		icon: <LogoutOutlined />,
		showInMenu: false,
		showHeader: false,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},
};

/** Solo la clave en Redux (los iconos JSX no son serializables). */
export const getRouteKeyFromPayload = (payload) => {
	if (!payload) return "projects";
	if (typeof payload === "string") {
		if (routes[payload]) return payload;
		const found = Object.values(routes).find(
			(r) => r.slug === payload || r.key === payload,
		);
		return found?.key || "projects";
	}
	if (payload.key && routes[payload.key]) return payload.key;
	return "projects";
};

export const resolveRoute = (key) => routes[key] || routes.projects;
